const has = obj => prop => obj !== undefined && obj !== null && typeof obj === 'object' && Object.prototype.hasOwnProperty.call(obj, prop);

export default has;



// WEBPACK FOOTER //
// ./src/helpers/has.js